import { type KeenSliderPlugin } from 'keen-slider'

import { type SanityImageFragment } from '@data/sanity/queries/types/image'
import { type FrameSettings } from '@frame-builder/lib/frame-viewer/settings'

export interface GalleryCarouselImageItem {
  type: 'image'
  id: string
  image: SanityImageFragment
}

interface GalleryCarousel3dPreviewItem {
  type: '3d-preview'
  id: string
  frameSettings: FrameSettings
}

export type GalleryCarouselItem =
  | GalleryCarouselImageItem
  | GalleryCarousel3dPreviewItem

type Timeout = ReturnType<typeof setTimeout>

interface Position {
  x: number
  y: number
}

export const WheelControls: KeenSliderPlugin = (slider) => {
  let touchTimeout: Timeout
  let position: Position
  let wheelActive: boolean

  function dispatch(event: WheelEvent, name: string) {
    position.x -= event.deltaX
    position.y -= event.deltaY
    slider.container.dispatchEvent(
      new CustomEvent(name, {
        detail: {
          x: position.x,
          y: position.y,
        },
      }),
    )
  }

  function wheelStart(event: WheelEvent) {
    position = {
      x: event.pageX,
      y: event.pageY,
    }
    dispatch(event, 'ksDragStart')
  }

  function wheel(event: WheelEvent) {
    dispatch(event, 'ksDrag')
  }

  function wheelEnd(event: WheelEvent) {
    dispatch(event, 'ksDragEnd')
  }

  function eventWheel(event: WheelEvent) {
    event.preventDefault()
    if (!wheelActive) {
      wheelStart(event)
      wheelActive = true
    }

    wheel(event)
    clearTimeout(touchTimeout)

    touchTimeout = setTimeout(() => {
      wheelActive = false
      wheelEnd(event)
    }, 50)
  }

  slider.on('created', () => {
    slider.container.addEventListener('wheel', eventWheel, {
      passive: false,
    })
  })
}
